import { Component } from '@angular/core';
import { NavbarComponent } from '../../components/navbars/navbar/navbar.component';
import { SideMenuComponent } from '../../components/navbars/side-menu/side-menu.component';
import { DataService } from '../../Services/Data Service/data.service';
import { AuditService } from '../../Services/Data Service/audit.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { filter, switchMap, take } from 'rxjs';
import { CacheService } from '../../Services/Data Service/cache.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { isAdminRole, isSuperAdminRole } from '../../roles';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [NavbarComponent, SideMenuComponent, FormsModule, CommonModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.css'
})
export class FaqComponent {
  constructor(
    private dataService: DataService,
    private auditService: AuditService,
    private cacheService: CacheService,
    private sanitizer: DomSanitizer
  ) { }
  isNavbarExpanded = false;
  currUser: any;
  role = '';
  loading = false;
  readonly isAdminRole = isAdminRole;
  readonly isSuperAdminRole = isSuperAdminRole;

  toggleCollapse(expanded: boolean) {
    this.isNavbarExpanded = expanded;
  }

  faqItems: any = null;


  isLightboxOpen = false;
  selectedVideoUrl: SafeResourceUrl = '';

  openLightbox(url: string): void {
    const hasQuery = url.includes('?');
    const params = [
      'autoplay=1',
      'enablejsapi=1',
      'origin=' + window.location.origin,
      'rel=0',
      'modestbranding=1'
    ];
    const paramString = params.join('&');
    const finalUrl = hasQuery 
      ? url + '&' + paramString 
      : url + '?' + paramString;
    this.selectedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(finalUrl);
    this.isLightboxOpen = true;
  }

  closeLightbox(): void {
    this.isLightboxOpen = false;
    this.selectedVideoUrl = '';
  }

  ngOnInit(): void { 
    this.fetchData()

    this.role = localStorage.getItem('role') || ''; 
    
    this.dataService.currentUser$.pipe(
      filter((u): u is NonNullable<typeof u> => u != null),
      take(1)
    ).subscribe({
      next: (loggedInUser) => {
        if (!loggedInUser.role) {
          console.error('User not found.');
          return;
        }
        this.currUser = loggedInUser;
      },
      error: (error) => {
        console.error('Error fetching logged-in user:', error);
      }
    });
  };

  fetchData() {
    const cacheKey = 'faqItems';
    const cached = this.cacheService.get<any[]>(cacheKey);

    if (cached) {
      // Use cached data immediately
      this.faqItems = cached.map((faq: any) => ({
        ...faq,
        isExpanded: false
      }));
      this.loading = false;

      // Refresh in background
      this.refreshFaqData(cacheKey);
      return;
    }

    // No cache, fetch fresh
    this.refreshFaqData(cacheKey);
  }

  private refreshFaqData(cacheKey: string): void {
    //FETCH QUESTIONS  FROM DB 
    this.loading = true;
    this.dataService.getFaqItems().subscribe({
      next: (result) => {
        this.faqItems = result.map((faq: any) => ({
          ...faq,
          isExpanded: false
        }));
        
        this.cacheService.set(cacheKey, result, 1000 * 60 * 5);

        this.loading = false;
      }, error: (error) => {
        console.error('Error:', error);
        this.loading = false;
      },
    });
  };

  toggleFaq(index: number): void {
    this.faqItems[index].isExpanded = !this.faqItems[index].isExpanded;
  }


  deleteFAQ(faqID: number) {
    if (!isSuperAdminRole(this.role)) {
      return;
    }
    const faqToDelete = this.faqItems.find((faqItem: { intFaqPK: number; }) => faqItem.intFaqPK === faqID);

    if (confirm('Are you sure you want to delete: "' + faqToDelete.strQuestion + '" ?')) {

      //Find FAQ and log the action
      if (faqToDelete) {
        this.auditService.submitAuditLog("Deleted FAQ: " + faqToDelete.strQuestion);
      }

      //Delete 
      this.dataService.deleteFAQ(faqID).subscribe(() => {
        this.faqItems = this.faqItems.filter( // Update local list after deletion
          (faqItem: { intFaqPK: number }) => faqItem.intFaqPK !== faqID
        );
        this.fetchData();
      });
    }
  }
  
}
